<template>
  <div class="sum-description-component">
    <item
        name="Subtotal recorrente"
        :price="totalRecurrentPrice"
        type="recurrent"
        :seasonality="formattedSeasonality"
        v-if="!onlyUnique"
    ></item>
    <item
        name="Subtotal único"
        :price="formatPrice(totalUniquePrice)"
        type="unique"
        :seasonality="0"
        v-if="!onlyUnique"
    ></item>
    <item name="TOTAL" :price="formatPrice(totalPrice)" type="total" :seasonality="0"></item>
  </div>
</template>

<script>

import Item from './Item'

export default {

  name: 'sum-description',

  props: {
    steps: {
      required: true,
      type: Array
    },
    formData: {
      required: true,
      type: Object
    },
    seasonality: {
      required: false,
      type: Number,
      default: () => 12
    },
    onlyUnique: {
      required: true,
      type: Boolean,
      default: () => false
    }
  },

  components: {
    Item
  },

  data() {
    return {
      totalRecurrentPrice: 0,
      totalUniquePrice: 0
    }
  },

  watch: {
    steps: {
      handler() {
        this.calculateRecurrentTotalPrice()
      },
      deep: true
    },
    'formData.extraServices.data': {
      handler() {
        this.calculateUniqueTotalPrice()
      },
      deep: true
    },
    'formData.plan.data': {
      handler() {
        this.calculateUniqueTotalPrice()
      },
      deep: true
    }
  },

  mounted() {
    this.calculateRecurrentTotalPrice()
    this.calculateUniqueTotalPrice()
  },

  computed: {
    totalPrice() {
      return (this.totalRecurrentPrice * this.formData.plan.data.seasonality) + this.totalUniquePrice
    },
    formattedSeasonality() {
      return this.formData.plan.data.seasonality
    }
  },

  methods: {
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },
    calculateRecurrentTotalPrice() {
      let total = 0
      for (const step of this.steps) {
        if (step.price !== null && step.hasSum) {
          total += parseFloat(step.price)
        }
      }
      this.totalRecurrentPrice = total
    },
    calculateUniqueTotalPrice() {
      let total = 0
      for (const extraService of this.formData.extraServices.data) {
        total += parseFloat(extraService.price) * extraService.quantity
      }
      total += parseFloat(this.formData.plan.data.setup_price)
      this.totalUniquePrice = total
    }
  }

}

</script>